import { Fragment } from "react/jsx-runtime";
import { H4, LI, P, UL } from "../../../../../AbstractElements";
import { CommonBerlinModalTitleType } from "../../../../../Types/UiKitsType";

const CommonBerlinModalTitle:React.FC<CommonBerlinModalTitleType> = ({ heading, subHeading, text }) => {
  return (
    <Fragment>
      <UL className="dot-group pb-3 pt-0 simple-list flex-row">
        <LI /><LI /><LI />
      </UL>
      <div className="title-wrapper pb-3 modal-heading">
        <H4 className="theme-name mb-0">
          <span>{heading}</span> {subHeading}
        </H4>
        <P className="text-gray">{text}</P>
      </div>
    </Fragment>
  );
};
export default CommonBerlinModalTitle;
